export const navData = [
  // {
  //   label: 'All Today',
  //   to: '/all-today',
  // },
  {
    label: 'Planner',
    to: '/planner',
  },
  {
    label: 'Bookmark',
    to: '/bookmark',
  },
  {
    label: 'Notes',
    to: '/notes',
  },
];

export const authNavData = [
  {
    label: 'Login',
    to: '/login',
  },
  {
    label: 'Sign up',
    to: '/sign-up',
  },
];
